const theme = {
  white: '#fff',
  black: '#16191a',
  darkBlack: '#0f1111',
  gray: '#515151',
  darkGray: '#3e3e3e',
  lightGray: '#f4f4f4',
  blue: '#69a4b8',
  midBlue: '#073342',
  darkBlue: '#5a8d9f',
  darkerBlue: '#27353a',
  lightBlue: '#acc6cf',
  lighterBlue: 'rgba(105, 164, 184, 0.2)',
  borderColor: '#cecece',
  gdprBorderColor: 'rgba(206, 206, 206, .2)',
  error: '#c4191f',
  success: '#71ac15',
  sansFont: '"HK", sans-serif',
  condensedFont: '"balboa-plus-fill", sans-serif',
  gridCols: 12,
};

export default theme;
